import React, { useState, useEffect, useContext } from "react";
import FETCH from "../../utils/fetch";
import { MODULE_API } from "../../apis";
import TAX_AND_INFLATION_API from "../../apis/tax_and_inflation.api";
import { useHistory } from "react-router-dom";
import { IncomeReport } from "./IncomeDashboardComponets/IncomeReport";
import { IncomeChart } from "./IncomeDashboardComponets/IncomeChart";
import { IncomeTable } from "./IncomeDashboardComponets/IncomeTable";
import "./IncomeDashboard.css";
import NewLoader from "../../components/styled-components/loader/NewLoader";
import swal from "sweetalert";
import moment from "moment";
import { ChartColors } from "../../components/ChartColors";
import { GlobalLoaderContext } from "../../utils/GlobalLoaderContext";
import ModalVideo from "../ModuleVideos/ModalVideo";
import { LoadingOutlined } from "@ant-design/icons";
import { useRef } from "react";
export const IncomeDashboard = () => {
  const history = useHistory();
  const { runWithLoader } = useContext(GlobalLoaderContext);
  const [loading, setLoading] = useState(false);
  const [incomeList, setIncomeList] = useState([]);
  const [dataReport, setDataReport] = useState(null);
  const [monthlyDataReport, setMonthlyDataReport] = useState(null);
  const [yearlyDataReport, setYearlyDataReport] = useState(null);
  const [chartData, setChartData] = useState(null);
  const [incomeReport, setIncomeReport] = useState(null);

  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [cachedData, setCachedData] = useState({});
  const [ssGlobalData, setSsGlobalData] = useState(null);
  const [taxInformationData, setTaxInformationData] = useState(null);
  const [downloadLoading, setDownloadLoading] = useState(false);
  const incomeReportRef = useRef(null);

  const handleDownloadReport = () => {
    if (downloadLoading || loading) return;
    if (incomeReportRef.current) {
      incomeReportRef.current.downloadPDF();
    }
  };


  const socialSecurityModule = "Social Security Calculator";
  const fetchSocialSecurityData = async () => {
    try {
      // setLoading(true);
      const res = await MODULE_API.fetchItems({
        moduleName: socialSecurityModule,
        pageNum: 1,
        limit: 1,
        body: {},
      });
      // console.log("resssssss", res);
      if (res && res.records && res.records.length > 0) {
        const socialSecuritydata = res.records[0];
        // const resultsAll = calculateSocialSecurityResults(res.records[0]);
        const extractedSSData = {
          ["Your Estimated Social Security"]:
            (socialSecuritydata &&
              socialSecuritydata["Your Monthly Benefit at FRA ($)"] &&
              parseFloat(
                socialSecuritydata["Your Monthly Benefit at FRA ($)"],
              ).toFixed(2)) ||
            0,
          ["Social Security - Spouse"]:
            (socialSecuritydata &&
              socialSecuritydata["Spouse Monthly Benefit at FRA ($)"] &&
              parseFloat(
                socialSecuritydata["Spouse Monthly Benefit at FRA ($)"],
              ).toFixed(2)) ||
            0,
          ["Your Estimated Social Security Start Age"]:
            (socialSecuritydata &&
              socialSecuritydata["Your Desired Claim Age"] &&
              parseInt(socialSecuritydata["Your Desired Claim Age"])) ||
            0,
          ["Social Security - Spouse Start Age"]:
            (socialSecuritydata &&
              socialSecuritydata["Spouse Desired Claim Age"] &&
              parseInt(socialSecuritydata["Spouse Desired Claim Age"])) ||
            0,
          ["Tax Filing Status"]:
            (socialSecuritydata &&
              socialSecuritydata["Tax Filing Status"] &&
              socialSecuritydata["Tax Filing Status"]) ||
            "Single",
        };

        if (socialSecuritydata && socialSecuritydata["Your Birthdate"]) {
          extractedSSData["Current Age"] = moment().diff(
            moment(socialSecuritydata["Your Birthdate"]),
            "years",
          );
        }

        if (socialSecuritydata && socialSecuritydata["Spouse Birthdate"]) {
          extractedSSData["Spouse's Current Age"] = moment().diff(
            moment(socialSecuritydata["Spouse Birthdate"]),
            "years",
          );
        }

        setSsGlobalData(extractedSSData);
        // setResults(resultsAll);
      }
    } catch (error) {
      console.error("Error fetching attributes", error);
    } finally {
      // setLoading(false);
    }
  };

  const getTaxInflationDetails = async () => {
    try {
      setLoading(true);
      let data = await TAX_AND_INFLATION_API.fetchTaxInflationDetails();
      if (data && data.data) {
        const taxInfoData = data.data[0];
        if (taxInfoData) {
          setTaxInformationData({
            "State Taxation": taxInfoData && taxInfoData.state ? taxInfoData.state : "",
            "City of Residence": taxInfoData && taxInfoData.city ? taxInfoData.city : "",
            "Tax Filing Election": taxInfoData && taxInfoData.taxFillingElection
              ? taxInfoData.taxFillingElection
              : "",
            Deductions: taxInfoData && taxInfoData.deductions ? taxInfoData.deductions : "",
            "State Tax Effective Rate": taxInfoData && taxInfoData.stateTaxRate
              ? taxInfoData.stateTaxRate
              : "",
            "Federal Tax Rate": taxInfoData && taxInfoData.federalTaxRate
              ? taxInfoData.federalTaxRate
              : "",
            "Total Tax Rate": taxInfoData && taxInfoData.totalTaxRate ? taxInfoData.totalTaxRate : "",
            "Federal Collectible Tax Rate": taxInfoData && taxInfoData.federalCollectibleTaxRate
              ? taxInfoData.federalCollectibleTaxRate
              : "",
            "Medical and Dental Expenses": taxInfoData && taxInfoData.medicalAndDentalExpenses
              ? taxInfoData.medicalAndDentalExpenses
              : "",
            "State and Local Taxes (SALT)": taxInfoData && taxInfoData.stateAndLocalTaxesSalt
              ? taxInfoData.stateAndLocalTaxesSalt
              : "",
            "Home Mortgage Interest": taxInfoData && taxInfoData.homeMortgageInterest
              ? taxInfoData.homeMortgageInterest
              : "",
            "Charitable Contributions": taxInfoData && taxInfoData.charitableContributions
              ? taxInfoData.charitableContributions
              : "",
            "Number of Dependents": taxInfoData && taxInfoData.noOfDependents
              ? taxInfoData.noOfDependents
              : "",
            ...taxInfoData,
          });
        }
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("error while fetching Tax Inflation Details", error);
    }
  };

  const getMockRecords = () => {
    const records = [];
    const today = moment();
    if (ssGlobalData) {
      if (
        ssGlobalData["Your Estimated Social Security"] > 0 &&
        ssGlobalData["Current Age"] >= ssGlobalData["Your Estimated Social Security Start Age"]
      ) {
        records.push({
          income_name: "Social Security (Self)",
          "Income Name": "Social Security (Self)",
          active_passive_val: "Passive",
          "Passive or Active": "Passive",
          frequency: "Monthly",
          "Frequency of Pay Periods": "Monthly",
          gross_monthly_wages: parseFloat(ssGlobalData["Your Estimated Social Security"]),
          "Gross Monthly Wages": parseFloat(ssGlobalData["Your Estimated Social Security"]),
          income_start_date: today.format("YYYY-MM-DD"),
          "Date Income Starts": today.format("YYYY-MM-DD"),
          income_end_date: today.clone().add(50, "years").format("YYYY-MM-DD"),
          "Date Income Ends": today.clone().add(50, "years").format("YYYY-MM-DD"),
          module: "Social Security",
        });
      }
      if (
        ssGlobalData["Social Security - Spouse"] > 0 &&
        ssGlobalData["Spouse's Current Age"] >= ssGlobalData["Social Security - Spouse Start Age"]
      ) {
        records.push({
          income_name: "Social Security (Spouse)",
          "Income Name": "Social Security (Spouse)",
          active_passive_val: "Passive",
          "Passive or Active": "Passive",
          frequency: "Monthly",
          "Frequency of Pay Periods": "Monthly",
          gross_monthly_wages: parseFloat(ssGlobalData["Social Security - Spouse"]),
          "Gross Monthly Wages": parseFloat(ssGlobalData["Social Security - Spouse"]),
          income_start_date: today.format("YYYY-MM-DD"),
          "Date Income Starts": today.format("YYYY-MM-DD"),
          income_end_date: today.clone().add(50, "years").format("YYYY-MM-DD"),
          "Date Income Ends": today.clone().add(50, "years").format("YYYY-MM-DD"),
          module: "Social Security",
        });
      }
    }
    return records;
  };

  const getNetValue = (item) => {
    if (!item) return 0;
    const module = item.module || item.Module || item.sub_type_val;
    const gross = parseFloat(item["Gross Monthly Wages"] || item.gross_monthly_wages || 0);
    const defaultEffTaxRate = (parseFloat(taxInformationData && taxInformationData["Total Tax Rate"]) || 0) / 100;

    switch (module) {
      case "Employee (W2)":
      case "Employee (W-2)": {
        const taxes =
          parseFloat(item["Federal Taxation"] || item.federal_taxation || 0) +
          parseFloat(item["State Taxation"] || item.state_taxation || 0) +
          parseFloat(item["Social Security Tax"] || item.social_security_tax || 0) +
          parseFloat(item["Medicare Tax"] || item.medicare_tax || 0) +
          parseFloat(item["Disability Insurance"] || item.disability_insurance || 0) +
          parseFloat(item["Retirement Contribution"] || item.retirement_contribution || 0);

        if (taxes === 0 && gross > 0) return gross - gross * defaultEffTaxRate;
        return gross - taxes;
      }
      case "Contractor-Owner (1099)":
      case "Contractor (1099)": {
        const grossProfit = parseFloat(item["Gross Profit"] || item.gross_profit || gross);
        let seTax = parseFloat(
          item["Estimated Self Employment Tax Liability"] ||
          item.estimated_self_employment_tax_liability ||
          0,
        );

        if (seTax === 0 && grossProfit > 0) {
          seTax = grossProfit * 0.9235 * 0.153;
        }

        return (
          grossProfit -
          (parseFloat(item["Total Expenses"] || item.total_expenses || 0) +
            seTax +
            parseFloat(
              item["Self Employment Health Insurance Premiums"] ||
              item.self_employment_health_insurance_premiums ||
              0,
            ) +
            parseFloat(
              item["Retirement Plan (SEP / Solo 401k)"] ||
              item.retirement_plan_sep_solo_401k ||
              0,
            ))
        );
      }
      case "Asset (K-1)":
      case "Investment-Asset (K-1)": {
        const ordInc = parseFloat(item["Ordinary Income"] || item.ordinary_income || 0);
        let effTaxRate = parseFloat(item["Effective Tax Rate"] || item.effective_tax_rate || 0);
        if (effTaxRate === 0) effTaxRate = parseFloat((taxInformationData && taxInformationData["Total Tax Rate"]) || 0);
        effTaxRate = effTaxRate / 100;
        const totalCredits = parseFloat(item["Total Tax Credits"] || item.total_tax_credits || 0);
        return ordInc - (ordInc * effTaxRate - totalCredits);
      }
      case "Real Estate Rental":
        return (
          gross -
          (parseFloat(item["Maintenance"] || item.maintenance || 0) +
            parseFloat(item["Property Tax"] || item.property_tax || 0) +
            parseFloat(item["Insurance"] || item.insurance || 0) +
            parseFloat(item["Management"] || item.management || 0) +
            parseFloat(item["Utilities"] || item.utilities || 0) +
            parseFloat(item["Mortgage Interest"] || item.mortgage_interest || 0))
        );
      case "RMD Distribution":
      case "Retirement (RMD)": {
        let effTaxRate = parseFloat(item["Effective Tax Rate"] || item.effective_tax_rate || 0);
        if (effTaxRate === 0) effTaxRate = parseFloat((taxInformationData && taxInformationData["Total Tax Rate"]) || 0);
        effTaxRate = effTaxRate / 100;
        return gross - gross * effTaxRate;
      }
      case "Social Security":
      case "Government and Military (Social Security)":
        return gross - gross * defaultEffTaxRate;
      default:
        return parseFloat(
          item["Net Amount"] || item.net_amount || item["Net Business Profit"] || gross,
        );
    }
  };

  const getIncomeList = async (page) => {
    if (cachedData && cachedData[page]) {
      setLoading(false);
      updateStateWithData(cachedData[page]);
      return;
    }
    try {
      setLoading(true);
      const attributeToFetch = [
        "Date Income Starts",
        "Gross Monthly Wages",
        "Date Income Ends",
        "Income Name",
        "Passive or Active",
        "Frequency of Pay Periods",
        "Net Amount",
        "module",
        "Total Expenses",
        "Estimated Self Employment Tax Liability",
        "Self Employment Health Insurance Premiums",
        "Retirement Plan (SEP / Solo 401k)",
        "Returns & Allowances",
        "Cost of Goods Sold (COGS)",
        "Gross Profit",
        "Federal Taxation",
        "State Taxation",
        "Social Security Tax",
        "Medicare Tax",
        "Disability Insurance",
        "Retirement Contribution",
        "Ordinary Income",
        "Effective Tax Rate",
        "Total Tax Credits",
        "Maintenance",
        "Property Tax",
        "Insurance",
        "Management",
        "Utilities",
        "Mortgage Interest",
      ];
      const userRole =
        localStorage.getItem("role") != "undefined" &&
        JSON.parse(localStorage.getItem("role"));
      const ID = localStorage.getItem("accessId");

      let datares = await FETCH.post({
        url: "client-module-service/client-module/list",
        id: userRole === "Financial Advisor Client"
          ? `?module=Income&page=${page}&limit=10&clientId=${ID}`
          : `?module=Income&page=${page}&limit=10`,
        body: { attributes: attributeToFetch },
      });
      if (datares && datares.records) {
        // setIncomeList(datares.records);
        setCachedData((prevState) => ({
          ...prevState,
          [page]: datares,
        }));
        updateStateWithData(datares);
        const totalRecords = [...datares.records, ...getMockRecords()];
        // Helper functions
        const isCurrentYear = (date) =>
          new Date(date).getFullYear() === new Date().getFullYear();
        const isCurrentMonth = (date) => {
          const today = new Date();
          const recordDate = new Date(date);
          return (
            recordDate.getFullYear() === today.getFullYear() &&
            recordDate.getMonth() === today.getMonth()
          );
        };
        const isValidRecord = (rec) =>
          rec["Passive or Active"] && rec["Gross Monthly Wages"] !== undefined;
        // Separate records by type
        const passiveRecords = totalRecords.filter(
          (rec) => isValidRecord(rec) && rec["Passive or Active"] === "Passive"
        );
        const activeRecords = totalRecords.filter(
          (rec) => isValidRecord(rec) && rec["Passive or Active"] === "Active"
        );

        // Total sums
        const totalPassiveSum = passiveRecords.reduce(
          (sum, rec) => sum + getNetValue(rec),
          0
        );
        const totalActiveSum = activeRecords.reduce(
          (sum, rec) => sum + getNetValue(rec),
          0
        );
        const totalSum = totalPassiveSum + totalActiveSum;

        // Current year sums
        const currentYearPassiveSum = passiveRecords
          .filter(
            (rec) =>
              isCurrentYear(rec["Date Income Starts"]) ||
              isCurrentYear(rec["Date Income Ends"])
          )
          .reduce((sum, rec) => sum + getNetValue(rec), 0);

        const currentYearActiveSum = activeRecords
          .filter(
            (rec) =>
              isCurrentYear(rec["Date Income Starts"]) ||
              isCurrentYear(rec["Date Income Ends"])
          )
          .reduce((sum, rec) => sum + getNetValue(rec), 0);

        // Current month sums
        const currentMonthPassiveSum = passiveRecords
          .filter(
            (rec) =>
              isCurrentMonth(rec["Date Income Starts"]) ||
              isCurrentMonth(rec["Date Income Ends"])
          )
          .reduce((sum, rec) => sum + getNetValue(rec), 0);

        const currentMonthActiveSum = activeRecords
          .filter(
            (rec) =>
              isCurrentMonth(rec["Date Income Starts"]) ||
              isCurrentMonth(rec["Date Income Ends"])
          )
          .reduce((sum, rec) => sum + getNetValue(rec), 0);

        const currentMonthTotalSum =
          currentMonthPassiveSum + currentMonthActiveSum;
        const currentYearTotalSum =
          currentYearPassiveSum + currentYearActiveSum;
        // Result object
        const resultObj = {
          totalPassiveSum,
          totalActiveSum,
          totalSum,
          currentYearPassiveSum,
          currentYearActiveSum,
          currentMonthPassiveSum,
          currentMonthActiveSum,
          currentMonthTotalSum,
          currentYearTotalSum,
        };
        setDataReport(resultObj);

        console.log("Current Year Active Sum:", resultObj);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  const getIncomeListAfterDelete = async (page) => {
    try {
      setLoading(true);
      const attributeToFetch = [
        "Date Income Starts",
        "Gross Monthly Wages",
        "Date Income Ends",
        "Income Name",
        "Passive or Active",
        "Frequency of Pay Periods",
        "Net Amount",
        "module",
        "Total Expenses",
        "Estimated Self Employment Tax Liability",
        "Self Employment Health Insurance Premiums",
        "Retirement Plan (SEP / Solo 401k)",
        "Returns & Allowances",
        "Cost of Goods Sold (COGS)",
        "Gross Profit",
        "Federal Taxation",
        "State Taxation",
        "Social Security Tax",
        "Medicare Tax",
        "Disability Insurance",
        "Retirement Contribution",
        "Ordinary Income",
        "Effective Tax Rate",
        "Total Tax Credits",
        "Maintenance",
        "Property Tax",
        "Insurance",
        "Management",
        "Utilities",
        "Mortgage Interest",
      ];
      const userRole =
        localStorage.getItem("role") != "undefined" &&
        JSON.parse(localStorage.getItem("role"));
      const ID = localStorage.getItem("accessId");
      let datares = await FETCH.post({
        url: "client-module-service/client-module/list",
        id: userRole === "Financial Advisor Client"
          ? `?module=Income&page=${page}&limit=10&clientId=${ID}`
          : `?module=Income&page=${page}&limit=10`,
        body: { attributes: attributeToFetch },
      });
      if (datares && datares.records) {
        // setIncomeList(datares.records);
        setCachedData((prevState) => ({
          ...prevState,
          [page]: datares,
        }));
        updateStateWithData(datares);
        const totalRecords = [...datares.records, ...getMockRecords()];
        // Helper functions
        const isCurrentYear = (date) =>
          new Date(date).getFullYear() === new Date().getFullYear();
        const isCurrentMonth = (date) => {
          const today = new Date();
          const recordDate = new Date(date);
          return (
            recordDate.getFullYear() === today.getFullYear() &&
            recordDate.getMonth() === today.getMonth()
          );
        };
        const isValidRecord = (rec) =>
          rec["Passive or Active"] && rec["Gross Monthly Wages"] !== undefined;
        // Separate records by type
        const passiveRecords = totalRecords.filter(
          (rec) => isValidRecord(rec) && rec["Passive or Active"] === "Passive"
        );
        const activeRecords = totalRecords.filter(
          (rec) => isValidRecord(rec) && rec["Passive or Active"] === "Active"
        );

        // Total sums
        const totalPassiveSum = passiveRecords.reduce(
          (sum, rec) => sum + getNetValue(rec),
          0
        );
        const totalActiveSum = activeRecords.reduce(
          (sum, rec) => sum + getNetValue(rec),
          0
        );
        const totalSum = totalPassiveSum + totalActiveSum;

        // Current year sums
        const currentYearPassiveSum = passiveRecords
          .filter(
            (rec) =>
              isCurrentYear(rec["Date Income Starts"]) ||
              isCurrentYear(rec["Date Income Ends"])
          )
          .reduce((sum, rec) => sum + getNetValue(rec), 0);

        const currentYearActiveSum = activeRecords
          .filter(
            (rec) =>
              isCurrentYear(rec["Date Income Starts"]) ||
              isCurrentYear(rec["Date Income Ends"])
          )
          .reduce((sum, rec) => sum + getNetValue(rec), 0);

        // Current month sums
        const currentMonthPassiveSum = passiveRecords
          .filter(
            (rec) =>
              isCurrentMonth(rec["Date Income Starts"]) ||
              isCurrentMonth(rec["Date Income Ends"])
          )
          .reduce((sum, rec) => sum + getNetValue(rec), 0);

        const currentMonthActiveSum = activeRecords
          .filter(
            (rec) =>
              isCurrentMonth(rec["Date Income Starts"]) ||
              isCurrentMonth(rec["Date Income Ends"])
          )
          .reduce((sum, rec) => sum + getNetValue(rec), 0);

        const currentMonthTotalSum =
          currentMonthPassiveSum + currentMonthActiveSum;
        const currentYearTotalSum =
          currentYearPassiveSum + currentYearActiveSum;
        // Result object
        const resultObj = {
          totalPassiveSum,
          totalActiveSum,
          totalSum,
          currentYearPassiveSum,
          currentYearActiveSum,
          currentMonthPassiveSum,
          currentMonthActiveSum,
          currentMonthTotalSum,
          currentYearTotalSum,
        };
        setDataReport(resultObj);

        console.log("Current Year Active Sum:", resultObj);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const updateStateWithData = (datares) => {
    if (datares && datares.records) {
      setIncomeList(datares.records);
    }
    if (datares && datares.pagination) {
      setTotalPages(
        Math.ceil(datares.pagination.total / datares.pagination.limit)
      );
    }
  };

  const deletePost = async (id) => {
    console.log("delete is", id);
    swal({
      title: "Are you sure?",
      text: "You want to delete this?",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async (result) => {
      if (result === true) {
        try {
          setLoading(true);
          const res = await MODULE_API.removeClientModule({
            clientModules: [id],
          });
          setCachedData({});
          setIncomeList([]);
          await getIncomeListAfterDelete(1);
          await getIncomeChartData();
          setLoading(false);
          // return res;
        } catch (error) {
          // setLoading(false);
          setLoading(false);
        }
      }
    });
  };

  const getIncomeTotalMonthly = async () => {
    try {
      setLoading(true);
      const date = moment();
      const startDate = date.startOf("month").format("YYYY-MM-DD"); // Start of the month
      const endDate = date.endOf("month").format("YYYY-MM-DD");
      let datares = await MODULE_API.fetchIncomeSum(startDate, endDate);
      if (datares && datares.data) {
        const monthlyData = datares.data;
        let monthlyResponse = {
          ...datares.data,
          totalMonthly: monthlyData
            ? (+monthlyData.Active || 0) + (+monthlyData.Passive || 0)
            : 0,
        };
        setMonthlyDataReport(monthlyResponse);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  const getIncomeTotalYearly = async () => {
    try {
      setLoading(true);
      const currentDate = moment();
      const startDate = currentDate
        .clone()
        .startOf("year")
        .format("YYYY-MM-DD");
      // const endDate = currentDate.clone().endOf("year").format("YYYY-MM-DD");
      const endDate = currentDate.clone().endOf("month").format("YYYY-MM-DD");
      let datares = await MODULE_API.fetchIncomeSum(startDate, endDate);
      if (datares && datares.data) {
        const yearlyData = datares.data;
        let yearlyResponse = {
          ...datares.data,
          totalYearly: yearlyData
            ? (+yearlyData.Active || 0) + (+yearlyData.Passive || 0)
            : 0,
        };
        setYearlyDataReport(yearlyResponse);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const getIncomeChartData = async () => {
    try {
      setLoading(true);
      const currentDate = moment();
      const startDate = currentDate
        .clone()
        .subtract(1, "year")
        .format("YYYY-MM-DD");

      const endDate = currentDate.clone().format("YYYY-MM-DD");
      let datares = await MODULE_API.fetchIncomeChartData(startDate, endDate);
      if (datares && datares.data) {
        const combinedData = [...datares.data, ...getMockRecords()];
        const generatedChartData = generateIncomeChartData(
          combinedData,
          startDate,
          endDate
        );
        const incomeSummary = calculateIncomeSummary(combinedData);
        setChartData(generatedChartData);
        setIncomeReport(incomeSummary);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  const calculateIncomeSummary = (incomeData) => {
    const currentYear = moment().year();
    const currentMonth = moment().format("MMM YYYY");
    const today = moment();
    const startOfYear = moment().startOf("year");

    let yearlyActiveIncome = 0;
    let yearlyPassiveIncome = 0;
    let monthlyActiveIncome = 0;
    let monthlyPassiveIncome = 0;

    const frequencyMultipliers = {
      Annually: 12,
      "Bi-Monthly": 2,
      "Bi-Weekly": 0.5, // 2 occurrences per month
      Monthly: 1,
      "One-Time": 0, // Applies only in the start month
      Quarterly: 3,
      "Semi-Annually": 6,
      Weekly: 0.25, // 4 occurrences per month
    };

    incomeData.forEach((item) => {
      const incomeStart = moment(item.income_start_date || today);
      const incomeEnd = moment(item.income_end_date || today);
      const frequency = item.frequency || "Monthly";
      const type = item.active_passive_val; // "Active" or "Passive"
      const monthlyIncome = getNetValue(item);

      if (!frequencyMultipliers.hasOwnProperty(frequency)) return;

      const interval = frequencyMultipliers[frequency];

      // Ensure the income period overlaps with the current year
      if (incomeEnd.isBefore(startOfYear) || incomeStart.isAfter(moment())) return;

      let effectiveStart = moment.max(incomeStart, startOfYear);
      let effectiveEnd = moment.min(incomeEnd, moment());

      for (
        let date = effectiveStart.clone();
        date.isSameOrBefore(effectiveEnd);
        date.add(1, "month")
      ) {
        const monthLabel = date.format("MMM YYYY");

        let occurrences = 1; // Default for monthly
        if (frequency === "Weekly") occurrences = 4;
        else if (frequency === "Bi-Weekly") occurrences = 2;
        else if (frequency === "One-Time") occurrences = date.isSame(effectiveStart, "month") ? 1 : 0;
        else if (interval > 1) occurrences = (date.month() - effectiveStart.month()) % interval === 0 ? 1 : 0;

        if (type === "Active") {
          yearlyActiveIncome += monthlyIncome * occurrences;
          if (monthLabel === currentMonth) {
            monthlyActiveIncome += monthlyIncome * occurrences;
          }
        } else {
          yearlyPassiveIncome += monthlyIncome * occurrences;
          if (monthLabel === currentMonth) {
            monthlyPassiveIncome += monthlyIncome * occurrences;
          }
        }
      }
    });

    return {
      yearlyActiveIncome: yearlyActiveIncome,
      yearlyPassiveIncome: yearlyPassiveIncome,
      monthlyActiveIncome: monthlyActiveIncome,
      monthlyPassiveIncome: monthlyPassiveIncome,
      totalYearly: yearlyActiveIncome + yearlyPassiveIncome,
      totalMonthly: monthlyActiveIncome + monthlyPassiveIncome,
    };
  };

  // generateIncomeChartData with frequncy but considering accoriding to frequncy.
  const generateIncomeChartData = (incomeData, startDate, endDate) => {
    const momentStartDate = moment(startDate);
    const momentEndDate = moment(endDate);

    // Generate dynamic month labels from start to end dates
    const monthLabels = [];
    let currentMonth = momentStartDate.clone();
    while (currentMonth.isSameOrBefore(momentEndDate)) {
      monthLabels.push(currentMonth.format("MMM YYYY"));
      currentMonth.add(1, "month");
    }

    const totalNetIncome = Array(monthLabels.length).fill(0);

    // Income frequencies and occurrences per month
    const frequencyMultipliers = {
      Annually: 12,
      "Bi-Monthly": 2,
      "Bi-Weekly": 0.5, // 2 occurrences per month
      Monthly: 1,
      "One-Time": 0, // Applies only in the start month
      Quarterly: 3,
      "Semi-Annually": 6,
      Weekly: 0.25, // 4 occurrences per month
    };

    const incomeDatasets = incomeData
      .map((item, index) => {
        const monthlyData = Array(monthLabels.length).fill(0);
        const incomeStart = moment(item.income_start_date);
        const incomeEnd = moment(item.income_end_date);
        const frequency = item.frequency || "Monthly";

        if (!frequencyMultipliers.hasOwnProperty(frequency)) return null;

        // Ensure the income period overlaps with the specified date range
        if (
          incomeEnd.isBefore(momentStartDate) ||
          incomeStart.isAfter(momentEndDate)
        )
          return null;

        const effectiveStart = moment.max(incomeStart, momentStartDate);
        const effectiveEnd = moment.min(incomeEnd, momentEndDate);

        const interval = frequencyMultipliers[frequency];
        const monthlyIncome = getNetValue(item);
        const monthlyWages = item.gross_monthly_wages;

        for (
          let date = effectiveStart.clone();
          date.isSameOrBefore(effectiveEnd);
          date.add(1, "month")
        ) {
          const monthIndex = monthLabels.findIndex(
            (label) => label === date.format("MMM YYYY")
          );
          if (monthIndex !== -1) {
            if (interval === 0) {
              // Handle One-Time Income
              if (frequency === "One-Time" && monthIndex === monthLabels.indexOf(effectiveStart.format("MMM YYYY"))) {
                monthlyData[monthIndex] += parseFloat(monthlyWages.toFixed(2));
                totalNetIncome[monthIndex] += parseFloat(monthlyIncome.toFixed(2));
              }
            } else if (interval <= 1) {
              // Weekly or Bi-Weekly
              const occurrences = frequency === "Weekly" ? 4 : frequency !== "Monthly" ? 2 : 1;
              monthlyData[monthIndex] += parseFloat((monthlyWages * occurrences).toFixed(2));
              totalNetIncome[monthIndex] += parseFloat((monthlyIncome * occurrences).toFixed(2));
            } else if ((monthIndex - monthLabels.indexOf(effectiveStart.format("MMM YYYY"))) % interval === 0) {
              // Quarterly, Bi-Monthly, Semi-Annually, Annually
              monthlyData[monthIndex] += parseFloat(monthlyWages.toFixed(2));
              totalNetIncome[monthIndex] += parseFloat(monthlyIncome.toFixed(2));
            }
          }
        }

        return {
          label: item.income_name || "Unnamed Income",
          type: "bar",
          data: monthlyData,
          backgroundColor: ChartColors[index % ChartColors.length],
          borderColor: ChartColors[index % ChartColors.length],
          stack: "stack1",
        };
      })
      .filter((dataset) => dataset !== null);

    // Add "Net Income" dataset
    let netIncomeChartData = {
      label: "Net Income",
      type: "line",
      data: totalNetIncome,
      fill: false,
      borderColor: "#11C4C1",
    };

    return {
      labels: monthLabels,
      datasets: [netIncomeChartData, ...incomeDatasets],
    };
  };

  useEffect(() => {
    getIncomeList(currentPage);
  }, [currentPage]);

  const getAll = async () => {
    // await getIncomeList(1);
    setLoading(true);
    await runWithLoader(async () => {
      await getTaxInflationDetails();
      await fetchSocialSecurityData();
      await getIncomeTotalMonthly();
      await getIncomeTotalYearly();
      await getIncomeChartData();
    }, () => {
      // 👇 This runs only if global loader actually shows after 4s
      setLoading(false);
    });
    setLoading(false);
  };
  useEffect(() => {
    getAll();
  }, []);

  return (
    <div className="incomeMain">
      <ModalVideo module="Source of Income" autoOpen={true} />
      <div className="Incomecreate" style={{ display: "flex", gap: "10px" }}>
        <button
          className="addbuttonincome"
          onClick={() => {
            history.push("/income_new");
          }}
        >
          {" "}
          + Add Income
        </button>

        <button
          className={`addbuttonassets addbuttonassets--secondary assets-download-button${
            downloadLoading || loading ? " addbuttonassets--loading" : ""
          }`}
          style={{ margin: 0, padding: "0.5rem" }}
          disabled={downloadLoading || loading}
          onClick={handleDownloadReport}
          aria-busy={downloadLoading || loading}
          aria-live="polite"
        >
          <span className="assets-download-icon-shell" aria-hidden="true">
            {downloadLoading || loading ? (
              <LoadingOutlined
                className="assets-download-icon"
                style={{ color: "#ffffff" }}
                spin
              />
            ) : (
              <svg
                className="assets-download-icon assets-download-svg-icon"
                viewBox="0 0 24 24"
                fill="none"
                aria-hidden="true"
              >
                <path
                  d="M12 4.5V14.5"
                  stroke="currentColor"
                  strokeWidth="2.25"
                  strokeLinecap="round"
                />
                <path
                  d="M8.5 11.5L12 15L15.5 11.5"
                  stroke="currentColor"
                  strokeWidth="2.25"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M6 18.5H18"
                  stroke="currentColor"
                  strokeWidth="2.25"
                  strokeLinecap="round"
                />
              </svg>
            )}
          </span>
          {downloadLoading
            ? "Downloading..."
            : loading
              ? "Preparing chart..."
              : "Download Report"}
        </button>
      </div>

      <div className="incomeMainReport" style={{ position: "relative" }}>
        <IncomeReport
          ref={incomeReportRef}
          data={dataReport && dataReport}
          monthlyDataReport={monthlyDataReport && monthlyDataReport}
          yearlyDataReport={yearlyDataReport && yearlyDataReport}
          incomeReport={incomeReport && incomeReport}
          chartData={chartData}
          onDownloadLoading={setDownloadLoading}
          isLoading={loading}
        />
        <NewLoader isLoading={loading} />
      </div>
      <div className="incomeTableCard" style={{ position: "relative" }}>
        <IncomeChart
          data={incomeList && incomeList}
          chartData={chartData && chartData}
          isLoading={loading}
        />
        <NewLoader isLoading={loading} />
      </div>
      <div className="incomeTableCard" style={{ position: "relative" }}>
        <IncomeTable
          data={incomeList && incomeList}
          isLoading={loading}
          getList={getIncomeList}
          deletePost={deletePost}
          page={currentPage}
          setCurrentPage={setCurrentPage}
          totalPages={totalPages}
        />
        <NewLoader isLoading={loading} />
      </div>
    </div>
  );
};
